// admin-builder.js — Staff builder (no cart/pay, PDF quote only)
// With cost tracking, profit margins, per-item custom retail price, and CUSTOM ITEMS
(function() {
  'use strict';

  var sel = { case:null, cpu:null, cooler:null, motherboard:null, ram:null, gpu:null, psu:null, ssd:null, fan:null, os:null, monitor:null, mouse:null, keyboard:null, headset:null };
  var COMPS = ['case','cpu','cooler','motherboard','ram','gpu','psu','ssd','fan','os','monitor','mouse','keyboard','headset'];
  var SOCKETS = ['lga1851','lga1700','lga1200','am5','am4'];
  var AIO_SIZES = ['360aio','280aio','240aio','120aio','420aio'];
  var FF = { itx:'Mini-ITX', matx:'Micro-ATX', atx:'ATX', eatx:'E-ATX' };
  var LABELS = { case:'PC Case', cpu:'CPU', cooler:'CPU Cooler', motherboard:'Motherboard', ram:'RAM', gpu:'Graphics Card', psu:'Power Supply', ssd:'Storage', fan:'Fan', os:'Operating System', monitor:'Monitor', mouse:'Mouse', keyboard:'Keyboard', headset:'Headset' };

  var CAT_DD_MAP = {
  'case':'abCaseDD', cpu:'abCpuDD', cooler:'abCoolerDD', motherboard:'abMbDD',
  ram:'abRamDD', gpu:'abGpuDD', psu:'abPsuDD', ssd:'abSsdDD', fan:'abFanDD',
  os:'abOsDD',
  monitor:'abMonitorDD', mouse:'abMouseDD', keyboard:'abKeyboardDD', headset:'abHeadsetDD'
};

  var $ = function(id) { return document.getElementById(id); };

  // ==================== LOAN CALCULATOR CONFIG ====================
  var LOAN_BANK_CONFIG = {
    'maybank':        { label: 'Maybank',                 months: [6, 12, 18, 24] },
    'affin':          { label: 'Affin Bank',              months: [6, 12, 24, 36] },
    'cimb':           { label: 'CIMB Bank',               months: [6, 12] },
    'hongleong':      { label: 'Hong Leong Bank',         months: [6, 12, 24, 36] },
    'uob':            { label: 'UOB Bank',                months: [6, 12, 24, 36] },
    'alliance':       { label: 'Alliance Bank',           months: [6, 12, 24, 36] },
    'ocbc':           { label: 'OCBC Bank',               months: [6, 12, 24, 36] },
    'sc':             { label: 'Standard Chartered Bank', months: [6, 12, 24, 36] },
    'ambank':         { label: 'AmBank',                  months: [6, 12, 24, 36] },
    'publicbank':     { label: 'Public Bank',             months: [6, 12, 24, 36] },
    'rhb':            { label: 'RHB Bank',                months: [6, 12, 24, 36] },
    'hsbc':           { label: 'HSBC Bank',               months: [6, 12, 24, 36] },
    'bsn':            { label: 'BSN',                     months: [6, 12, 24, 36] },
    'bankislam':      { label: 'Bank Islam',              months: [6, 12, 24, 36] },
    'aeoncreditcard': { label: 'Aeon Credit Card',        months: [6, 12, 18] }
  };
  var CC_FEES = { 6: 5, 12: 6, 18: 7, 24: 8, 36: 10 };

  // ── AEON Credit Service config ──
  // Monthly interest rate depends on finance amount:
  //   ≤ RM5,000  → 1.25% / month
  //   > RM5,000  → 1.10% / month (new customer); AEON Express / Cardholder → 1.00% (not shown in builder, use 1.10 as default)
  // Available months: 6, 12, 18, 24, 30, 36
  // Processing fee: RM50 (flat)
  // Stamping fee (new implement) tiered by finance amount:
  var AEON_MONTHS = [6, 12, 18, 24, 30, 36];
  var AEON_PROCESSING_FEE = 50;

  function getAeonMonthlyRate(principal) {
    return principal <= 5000 ? 1.25 : 1.10;
  }

  // Stamping fee tiers (upper bound inclusive)
  var AEON_STAMPING_TIERS = [
    { max: 999.99,   fee: 5  },
    { max: 2000.00,  fee: 10 },
    { max: 3000.00,  fee: 15 },
    { max: 4000.00,  fee: 20 },
    { max: 5000.00,  fee: 25 },
    { max: 6000.00,  fee: 30 },
    { max: 7000.00,  fee: 35 },
    { max: 8000.00,  fee: 40 },
    { max: 9000.00,  fee: 45 },
    { max: 10000.00, fee: 50 }
  ];

  function getAeonStampingFee(principal) {
    for (var i = 0; i < AEON_STAMPING_TIERS.length; i++) {
      if (principal <= AEON_STAMPING_TIERS[i].max) return AEON_STAMPING_TIERS[i].fee;
    }
    return 50; // cap at RM50 for >RM10,000
  }

  // ── BNPL providers (Atome removed; SPayLater 3%, GrabPay 6%, up to 12 months) ──
  var BNPL_PROVIDERS = {
    'grab':     { label: 'GrabPay Later',  months: 12, feeRate: 6  },
    'shopback': { label: 'SPayLater',      months: 12, feeRate: 3  }
  };

  var activeLoanPlanTypes    = [];
  var activeLoanCCBank       = null;
  var activeLoanBNPLProvider = null;
  var loanPDFData            = [];

  // PDF price visibility toggle
  var pdfShowPrices = true;

  // ==================== DISCOUNT STATE ====================
  var discountMode  = 'pct';   // 'pct' | 'fixed'
  var discountValue = 0;

  function getDiscountAmt() {
    var subtotal = getTotal();
    if (!discountValue || discountValue <= 0 || subtotal <= 0) return 0;
    if (discountMode === 'pct') {
      var d = subtotal * (discountValue / 100);
      return d > subtotal ? subtotal : d;
    }
    return discountValue > subtotal ? subtotal : discountValue;
  }

  function getNettTotal() { return getTotal() - getDiscountAmt(); }

  // ==================== CUSTOM ITEMS STATE ====================
  var customItems = [];
  var ciImageData = null;

  function ciLoad() {
    try { var s = localStorage.getItem('ab_custom_items'); if (s) customItems = JSON.parse(s); } catch(e) { customItems = []; }
  }
  function ciSave() {
    try { localStorage.setItem('ab_custom_items', JSON.stringify(customItems)); } catch(e) {}
  }

  // ==================== CUSTOM ITEMS — INJECT INTO DROPDOWNS ====================
  function ciInjectAll() {
    document.querySelectorAll('option[data-custom-item]').forEach(function(o) { o.remove(); });
    customItems.forEach(function(item) {
      var ddId = CAT_DD_MAP[item.category];
      var dd = ddId ? $(ddId) : null;
      if (!dd) return;
      var opt = document.createElement('option');
      opt.value = 'custom_' + item.id;
      opt.setAttribute('data-custom-item', 'true');
      opt.setAttribute('data-title', item.name);
      opt.setAttribute('data-price', 'RM ' + parseFloat(item.price).toFixed(2));
      opt.setAttribute('data-price-raw', String(item.price));
      opt.setAttribute('data-cost-raw', String(item.costPrice || 0));
      opt.setAttribute('data-tags', item.category);
      opt.setAttribute('data-image', item.image || '');
      opt.setAttribute('data-handle', '');
      opt.setAttribute('data-info-url', '');
      opt.textContent = '★ ' + item.name + ' - RM ' + parseFloat(item.price).toFixed(2) + ' [CUSTOM]';
      if (dd.options.length > 1) { dd.insertBefore(opt, dd.options[1]); } else { dd.appendChild(opt); }
    });
    ciUpdateToolbar();
  }

  function ciUpdateToolbar() {
    var manageBtn = $('abManageCustomBtn');
    var countEl = $('abCustomItemCount');
    if (manageBtn) manageBtn.style.display = customItems.length > 0 ? 'inline-flex' : 'none';
    if (countEl) countEl.textContent = customItems.length;
  }

  function ciCleanSelections() {
    COMPS.forEach(function(comp) {
      var p = sel[comp];
      if (p && p.isCustomItem) {
        var exists = customItems.some(function(ci) { return ci.id === p.customItemId; });
        if (!exists) { sel[comp] = null; var ddId = CAT_DD_MAP[comp]; if (ddId) $(ddId).value = ''; }
      }
    });
  }

  // ==================== CUSTOM ITEM — IMAGE HANDLING ====================
  window.abCiHandleImage = function(event) {
    var file = event.target.files && event.target.files[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) { alert('Image must be under 2MB.'); event.target.value = ''; return; }
    var reader = new FileReader();
    reader.onload = function(e) {
      ciImageData = e.target.result;
      var preview = $('abCiPreview'), ph = $('abCiUploadPh'), rm = $('abCiPreviewRm'), area = $('abCiUpload');
      if (preview) { preview.src = ciImageData; preview.style.display = 'block'; }
      if (ph) ph.style.display = 'none';
      if (rm) rm.style.display = 'flex';
      if (area) area.classList.add('has-image');
    };
    reader.readAsDataURL(file);
  };

  window.abCiRemoveImage = function(event) {
    if (event) { event.stopPropagation(); event.preventDefault(); }
    ciImageData = null;
    var preview = $('abCiPreview'), ph = $('abCiUploadPh'), rm = $('abCiPreviewRm'), area = $('abCiUpload'), input = $('abCiFileInput');
    if (preview) { preview.src = ''; preview.style.display = 'none'; }
    if (ph) ph.style.display = 'flex';
    if (rm) rm.style.display = 'none';
    if (area) area.classList.remove('has-image');
    if (input) input.value = '';
  };

  // ==================== CUSTOM ITEM — OPEN / CLOSE MODAL ====================
  window.abOpenCustomItemModal = function() {
    ['abCiName','abCiPrice','abCiCost','abCiCategory'].forEach(function(id) { var el = $(id); if(el) el.value = ''; });
    window.abCiRemoveImage();
    var m = $('abCiMargin'); if (m) m.style.display = 'none';
    var overlay = $('abCiOverlay');
    if (overlay) overlay.classList.add('active');
    setTimeout(function() { var n = $('abCiName'); if(n) n.focus(); }, 200);
  };

  window.abCloseCustomItemModal = function(event) {
    if (event && event.target !== event.currentTarget) return;
    var overlay = $('abCiOverlay');
    if (overlay) overlay.classList.remove('active');
  };

  // ==================== CUSTOM ITEM — SUBMIT ====================
  window.abCiSubmit = function() {
    var name = ($('abCiName') || {}).value || '';
    var price = parseFloat(($('abCiPrice') || {}).value) || 0;
    var costPrice = parseFloat(($('abCiCost') || {}).value) || 0;
    var category = ($('abCiCategory') || {}).value || '';
    if (!name.trim()) { alert('Please enter an item name.'); $('abCiName').focus(); return; }
    if (price <= 0) { alert('Please enter a valid selling price.'); $('abCiPrice').focus(); return; }
    if (!category) { alert('Please select a category.'); $('abCiCategory').focus(); return; }
    var item = {
      id: 'ci_' + Date.now() + '_' + Math.random().toString(36).substr(2,5),
      name: name.trim(), price: price, costPrice: costPrice || 0,
      category: category, image: ciImageData || null, createdAt: new Date().toISOString()
    };
    customItems.push(item);
    ciSave(); ciInjectAll(); window.abCloseCustomItemModal();
  };

  // ==================== CUSTOM ITEM — DELETE ====================
  window.abCiDeleteItem = function(itemId) {
    if (!confirm('Delete this custom item? It will be removed from the dropdown.')) return;
    customItems = customItems.filter(function(i) { return i.id !== itemId; });
    ciSave(); ciCleanSelections(); ciInjectAll(); onChange('case'); abRenderManageList();
  };

  window.abCiClearAll = function() {
    if (!confirm('Delete ALL custom items? This cannot be undone.')) return;
    customItems = []; ciSave(); ciCleanSelections(); ciInjectAll(); onChange('case'); abRenderManageList();
  };

  // ==================== CUSTOM ITEM — MANAGE MODAL ====================
  window.abOpenManageCustomItems = function() {
    abRenderManageList();
    var overlay = $('abCiManageOverlay');
    if (overlay) overlay.classList.add('active');
  };

  window.abCloseManageCustomItems = function(event) {
    if (event && event.target !== event.currentTarget) return;
    var overlay = $('abCiManageOverlay');
    if (overlay) overlay.classList.remove('active');
  };

  function abRenderManageList() {
    var list = $('abCiManageList'), empty = $('abCiManageEmpty'), clearBtn = $('abCiClearAll');
    if (!list) return;
    list.innerHTML = '';
    if (customItems.length === 0) {
      if (empty) empty.style.display = 'block';
      if (clearBtn) clearBtn.style.display = 'none';
      return;
    }
    if (empty) empty.style.display = 'none';
    if (clearBtn) clearBtn.style.display = 'inline-flex';
    customItems.forEach(function(item) {
      var thumbHtml = item.image
        ? '<img src="' + item.image + '" alt="">'
        : '<span class="ab-ci-manage-thumb-ph">' + (item.category || '?').slice(0,3) + '</span>';
      var catLabel = (LABELS[item.category] || item.category || '').toUpperCase();
      var div = document.createElement('div');
      div.className = 'ab-ci-manage-item';
      div.innerHTML =
        '<div class="ab-ci-manage-thumb">' + thumbHtml + '</div>' +
        '<div class="ab-ci-manage-info">' +
          '<span class="ab-ci-manage-name">' + escHtml(item.name) + '</span>' +
          '<div class="ab-ci-manage-meta">' +
            '<span class="ab-ci-manage-cat">' + catLabel + '</span>' +
            '<span class="ab-ci-manage-price">RM ' + parseFloat(item.price).toFixed(2) + '</span>' +
            (item.costPrice > 0 ? '<span class="ab-ci-manage-cost">Cost: RM ' + parseFloat(item.costPrice).toFixed(2) + '</span>' : '') +
          '</div>' +
        '</div>' +
        '<button class="ab-ci-manage-rm" onclick="abCiDeleteItem(\'' + item.id + '\')" title="Delete">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>' +
        '</button>';
      list.appendChild(div);
    });
  }

  // ==================== CUSTOM ITEM — MARGIN PREVIEW IN MODAL ====================
  function ciSetupMarginPreview() {
    var priceEl = $('abCiPrice'), costEl = $('abCiCost');
    function update() {
      var price = parseFloat((priceEl||{}).value) || 0;
      var cost = parseFloat((costEl||{}).value) || 0;
      var m = $('abCiMargin'), valEl = $('abCiMarginVal'), pctEl = $('abCiMarginPct');
      if (price > 0 && cost > 0) {
        var margin = price - cost;
        var pct = ((margin / price) * 100).toFixed(1);
        if (m) { m.style.display = 'flex'; m.classList.toggle('negative', margin < 0); }
        if (valEl) valEl.textContent = (margin < 0 ? '-' : '') + 'RM ' + Math.abs(margin).toFixed(2);
        if (pctEl) pctEl.textContent = '(' + pct + '%)';
      } else { if (m) m.style.display = 'none'; }
    }
    if (priceEl) priceEl.addEventListener('input', update);
    if (costEl) costEl.addEventListener('input', update);
  }

  // ==================== PRICE HELPERS ====================
  function getItemPrice(item) {
    if (!item) return 0;
    return (item.customPrice !== undefined && item.customPrice !== null) ? item.customPrice : item.priceRaw;
  }
  function getTotal() { return Object.values(sel).filter(Boolean).reduce(function(s,i){ return s + getItemPrice(i) * (i.qty||1); }, 0); }
  function getTotalCost() { return Object.values(sel).filter(Boolean).reduce(function(s,i){ return s + (i.costRaw||0) * (i.qty||1); }, 0); }

  // ==================== INIT ====================
  document.addEventListener('DOMContentLoaded', function() {
    ciLoad();
    setupAccordion();
    setupFilters();
    setupDropdowns();
    setupDropdownSearch();
    setupQtyDelegation();
    ciSetupMarginPreview();
    setupLoanCalculator();
    setupDiscountControls();
    filterCPUs('intel');
    filterCoolers('air');
    filterCases('all');
    filterFans('all');
    ciInjectAll();
    abOpenSection(1);
    updateSidebar();

    var quoteBtn = $('abDownloadQuote');
    if (quoteBtn) quoteBtn.addEventListener('click', generateQuotePDF);

    var resetBtn = $('abResetBuild');
    if (resetBtn) resetBtn.addEventListener('click', resetBuild);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        window.abCloseCustomItemModal();
        window.abCloseManageCustomItems();
        window.abCloseLoanModal();
      }
    });
  });

  // ==================== ACCORDION ====================
  function setupAccordion() {
    document.querySelectorAll('.ab-header').forEach(function(h) {
      h.addEventListener('click', function() {
        var sec = h.closest('.ab-section');
        var num = +sec.dataset.section;
        if (sec.classList.contains('ab-open')) sec.classList.remove('ab-open');
        else abOpenSection(num);
      });
    });
  }

  function abOpenSection(num) {
    document.querySelectorAll('.ab-section').forEach(function(s){ s.classList.remove('ab-open'); });
    var t = document.querySelector('.ab-section[data-section="'+num+'"]');
    if (t) t.classList.add('ab-open');
  }

  // ==================== FILTERS ====================
  function setupFilters() {
    var bindings = {
      'ab-case-ff': filterCases,
      'ab-cpu-brand': filterCPUs,
      'ab-cooler-type': filterCoolers,
      'ab-fan-size': filterFans
    };
    Object.entries(bindings).forEach(function(entry) {
      document.querySelectorAll('input[name="'+entry[0]+'"]').forEach(function(r) {
        r.addEventListener('change', function() { if(this.checked) entry[1](this.value); });
      });
    });
  }

  function filterCases(ff) {
    document.querySelectorAll('#abCaseDD option').forEach(function(o) {
      if (!o.value) return;
      if (o.hasAttribute('data-custom-item')) { o.style.display = ''; o.removeAttribute('data-hidden-by-filter'); return; }
      if (ff === 'all') { o.style.display = ''; o.removeAttribute('data-hidden-by-filter'); return; }
      var m = getFF(o.dataset.tags) === ff;
      o.style.display = m ? '' : 'none';
      m ? o.removeAttribute('data-hidden-by-filter') : o.setAttribute('data-hidden-by-filter','true');
    });
  }

  function filterCPUs(brand) {
    document.querySelectorAll('#abCpuDD option').forEach(function(o) {
      if (!o.value) return;
      if (o.hasAttribute('data-custom-item')) { o.style.display = ''; o.removeAttribute('data-hidden-by-filter'); return; }
      var b = o.getAttribute('data-brand');
      var m = (b === brand || b === 'other' || !b);
      o.style.display = m ? '' : 'none';
      m ? o.removeAttribute('data-hidden-by-filter') : o.setAttribute('data-hidden-by-filter','true');
    });
  }

  function filterCoolers(type) {
    document.querySelectorAll('#abCoolerDD option').forEach(function(o) {
      if (!o.value) return;
      if (o.hasAttribute('data-custom-item')) { o.style.display = ''; o.removeAttribute('data-hidden-by-filter'); return; }
      var show = o.dataset.coolerType === type;
      o.style.display = show ? '' : 'none';
      show ? o.removeAttribute('data-hidden-by-filter') : o.setAttribute('data-hidden-by-filter','true');
    });
    updateCoolerNote(type);
  }

  function filterFans(size) {
    document.querySelectorAll('#abFanDD option').forEach(function(o) {
      if (!o.value) return;
      if (o.hasAttribute('data-custom-item')) { o.style.display = ''; o.removeAttribute('data-hidden-by-filter'); return; }
      var show = size === 'all' ? true : (o.dataset.tags||'').toLowerCase().includes(size);
      o.style.display = show ? '' : 'none';
      show ? o.removeAttribute('data-hidden-by-filter') : o.setAttribute('data-hidden-by-filter','true');
    });
  }

  function filterMotherboards() {
    var hasCase = !!sel.case, hasCPU = !!sel.cpu;
    var caseFF = hasCase ? getFF(sel.case.tags) : null;
    var cpuSock = hasCPU ? getSocket(sel.cpu.tags) : null;
    var count = 0;
    document.querySelectorAll('#abMbDD option').forEach(function(o) {
      if (!o.value) return;
      if (o.hasAttribute('data-custom-item')) { o.style.display = ''; o.removeAttribute('data-hidden-by-filter'); count++; return; }
      var tags = o.dataset.tags, ff = getFF(tags);
      var ok = true;
      if (hasCase && caseFF) ok = ok && isMBFit(caseFF, ff);
      if (hasCPU && cpuSock) ok = ok && (tags||'').toLowerCase().includes(cpuSock);
      o.style.display = ok ? '' : 'none';
      ok ? o.removeAttribute('data-hidden-by-filter') : o.setAttribute('data-hidden-by-filter','true');
      if (ok) count++;
    });
    var note = $('abMbNote');
    if (note) {
      if (hasCase || hasCPU) {
        var parts = [];
        if (hasCase) parts.push((FF[caseFF]||caseFF||'')+ ' case');
        if (hasCPU) parts.push((cpuSock||'').toUpperCase()+' socket');
        note.textContent = count + ' boards compatible with ' + parts.join(' & ');
        note.classList.add('ab-visible');
      } else note.classList.remove('ab-visible');
    }
  }

  function filterRAM() {
    var ddr = sel.motherboard ? getDDR(sel.motherboard.tags) : null;
    var note = $('abRamNote');
    document.querySelectorAll('#abRamDD option').forEach(function(o) {
      if (!o.value) return;
      if (o.hasAttribute('data-custom-item')) { o.style.display = ''; o.removeAttribute('data-hidden-by-filter'); return; }
      var show = !ddr ? true : o.dataset.ddrType === ddr;
      o.style.display = show ? '' : 'none';
      show ? o.removeAttribute('data-hidden-by-filter') : o.setAttribute('data-hidden-by-filter','true');
    });
    if (note) {
      if (ddr) { note.textContent = 'Compatible ' + ddr.toUpperCase() + ' RAM'; note.classList.add('ab-visible'); }
      else note.classList.remove('ab-visible');
    }
  }

  function updateCoolerNote(type) {
    var note = $('abCoolerNote');
    if (!note) return;
    var caseAIO = sel.case ? getAIOSupport(sel.case.tags) : null;
    if (type === 'water' && caseAIO) {
      note.textContent = 'Case supports: ' + caseAIO.map(function(s){ return s.replace('aio','mm').toUpperCase(); }).join(', ');
      note.classList.add('ab-visible');
    } else note.classList.remove('ab-visible');
  }

  function updatePSUNote() {
    var note = $('abPsuNote');
    if (!note) return;
    if (!sel.gpu) { note.classList.remove('ab-visible'); return; }
    var rec = sel.gpu.recommendedWattage;
    if (rec) { note.textContent = '⚡ Recommended: ' + rec + 'W+ for ' + sel.gpu.title; note.classList.add('ab-visible'); }
    else note.classList.remove('ab-visible');
  }

  // ==================== TAG HELPERS ====================
  function getDDR(t) { if(!t) return null; var l=t.toLowerCase(); return l.includes('ddr5')?'ddr5':l.includes('ddr4')?'ddr4':null; }
  function getFF(t) { if(!t) return null; var l=t.toLowerCase(); return l.includes('eatx')||l.includes('e-atx')?'eatx':l.includes('matx')||l.includes('micro-atx')||l.includes('m-atx')?'matx':l.includes('mini-itx')||l.includes('mini itx')||l.includes('itx')?'itx':l.includes('atx')?'atx':null; }
  function getSocket(t) { return t?SOCKETS.find(function(s){return t.toLowerCase().includes(s);})||null:null; }
  function getAIOSupport(t) { if(!t) return null; var r=AIO_SIZES.filter(function(s){return t.toLowerCase().includes(s);}); return r.length?r:null; }
  function isMBFit(cFF,mFF) { if(!cFF||!mFF) return true; var c={itx:['itx'],matx:['itx','matx'],atx:['itx','matx','atx'],eatx:['itx','matx','atx','eatx']}; return (c[cFF]||[]).indexOf(mFF)>-1; }
  function escHtml(s) { var d = document.createElement('div'); d.textContent = s||''; return d.innerHTML; }

  // ==================== DROPDOWNS ====================
  function setupDropdowns() {
    document.querySelectorAll('.ab-dropdown').forEach(function(dd) {
      dd.addEventListener('change', function() {
        if (dd._lbHandled) { dd._lbHandled = false; return; }
        handleDDChange(dd);
      });
    });
  }

  function handleDDChange(dd) {
    var comp = dd.dataset.component;
    var opt = dd.options[dd.selectedIndex];
    if (!opt || !opt.value) { sel[comp] = null; onChange(comp); return; }
    var isCustom = opt.hasAttribute('data-custom-item');
    var d = {
      id: opt.value, title: opt.dataset.title, price: opt.dataset.price,
      priceRaw: parseFloat(opt.dataset.priceRaw),
      costRaw: parseFloat(opt.dataset.costRaw) || 0,
      tags: opt.dataset.tags,
      brand: opt.dataset.brand, image: opt.dataset.image, ddrType: opt.dataset.ddrType,
      coolerType: opt.dataset.coolerType, wattage: opt.dataset.wattage,
      recommendedWattage: opt.dataset.recommendedWattage, infoUrl: opt.dataset.infoUrl||'',
      qty: 1, customPrice: null,
      isCustomItem: isCustom,
      customItemId: isCustom ? opt.value.replace('custom_','') : null
    };
    if (comp === 'case') handleCase(d);
    else if (comp === 'cpu') handleCPU(d);
    else if (comp === 'motherboard') handleMB(d);
    else if (comp === 'gpu') { sel.gpu = d; updatePSUNote(); }
    else sel[comp] = d;
    onChange(comp);
  }

  function handleCase(d) {
    sel.case = d;
    filterMotherboards();
    var ct = document.querySelector('input[name="ab-cooler-type"]:checked');
    filterCoolers(ct ? ct.value : 'air');
  }

  function handleCPU(d) {
    var oldSock = sel.cpu ? getSocket(sel.cpu.tags) : null;
    sel.cpu = d;
    var newSock = getSocket(d.tags);
    if (oldSock !== newSock && sel.motherboard) {
      if (newSock && !(sel.motherboard.tags||'').toLowerCase().includes(newSock)) {
        sel.motherboard = null; sel.ram = null;
        $('abMbDD').value = ''; $('abRamDD').value = '';
      }
    }
    filterMotherboards();
  }

  function handleMB(d) {
    var oldDDR = sel.motherboard ? getDDR(sel.motherboard.tags) : null;
    sel.motherboard = d;
    var newDDR = getDDR(d.tags);
    if (oldDDR !== newDDR && sel.ram && getDDR(sel.ram.tags) !== newDDR) {
      sel.ram = null; $('abRamDD').value = '';
    }
    filterRAM();
  }

  function onChange(comp) {
    updateAccordionState();
    updateSidebar();
  }

  function updateAccordionState() {
    var secComps = {
  1:['case'], 2:['cpu'], 3:['cooler'], 4:['motherboard'], 5:['ram'],
  6:['gpu'], 7:['psu'], 8:['ssd'], 9:['fan'],
  10:['os'],
  11:['monitor','mouse','keyboard','headset']
};
    Object.entries(secComps).forEach(function(entry) {
      var sec = document.querySelector('.ab-section[data-section="'+entry[0]+'"]');
      if (!sec) return;
      var hasAny = entry[1].some(function(c){ return sel[c]!==null; });
      sec.classList.toggle('ab-has-selection', hasAny);
      var nameEl = sec.querySelector('.ab-selected');
      if (nameEl) {
        if (entry[1].length === 1 && sel[entry[1][0]]) {
          var p = sel[entry[1][0]], q = p.qty||1;
          nameEl.textContent = p.title + (q>1?' × '+q:'');
        } else if (entry[1].length > 1) {
          var cnt = entry[1].filter(function(c){return sel[c];}).length;
          nameEl.textContent = cnt ? cnt+' selected' : '';
        } else nameEl.textContent = '';
      }
    });
  }

  // ==================== SIDEBAR ====================
  function updateSidebar() {
    var container = $('abSidebarItems');
    var empty = $('abSidebarEmpty');
    if (!container) return;
    container.querySelectorAll('.ab-sidebar-row').forEach(function(r){ r.remove(); });
    var total = 0, totalCost = 0, hasAny = false;

    COMPS.forEach(function(comp) {
      var p = sel[comp];
      if (!p) return;
      hasAny = true;
      var qty = p.qty||1;
      var effectivePrice = getItemPrice(p);
      var itemTotal = effectivePrice * qty;
      var itemCost = (p.costRaw||0) * qty;
      var itemProfit = itemTotal - itemCost;
      total += itemTotal;
      totalCost += itemCost;

      var hasChanged = (p.customPrice !== null && p.customPrice !== undefined && p.customPrice !== p.priceRaw);
      var isCustom = !!p.isCustomItem;

      var costLineHtml = '';
      if (p.costRaw > 0) {
        var profitClass = itemProfit < 0 ? 'ab-sidebar-profit-val negative' : 'ab-sidebar-profit-val';
        costLineHtml = '<div class="ab-sidebar-cost-line"><span class="ab-sidebar-cost-val">Cost: RM ' + itemCost.toFixed(2) + '</span><span class="' + profitClass + '">' + (itemProfit >= 0 ? '+' : '-') + 'RM ' + Math.abs(itemProfit).toFixed(2) + '</span></div>';
      } else {
        costLineHtml = '<div class="ab-sidebar-cost-line"><span class="ab-sidebar-no-cost">No cost set</span></div>';
      }

      var priceEditHtml =
        '<div class="ab-sidebar-price-edit">' +
          (hasChanged ? '<span class="ab-sidebar-original-price">RM ' + p.priceRaw.toFixed(2) + '</span>' : '') +
          '<div class="ab-price-input-wrap' + (hasChanged ? ' ab-price-changed' : '') + '">' +
            '<span class="ab-price-rm">RM</span>' +
            '<input type="number" class="ab-price-input" data-comp="' + comp + '" step="0.01" min="0" value="' + effectivePrice.toFixed(2) + '" placeholder="' + p.priceRaw.toFixed(2) + '">' +
          '</div>' +
          (qty > 1 ? '<span class="ab-price-qty-hint">× ' + qty + ' = RM ' + itemTotal.toFixed(2) + '</span>' : '') +
        '</div>';

      var customTag = isCustom ? '<span class="ab-sidebar-custom-tag">Custom</span>' : '';

      var row = document.createElement('div');
      row.className = 'ab-sidebar-row' + (isCustom ? ' ab-sidebar-row--custom' : '');
      row.innerHTML =
        '<div class="ab-sidebar-thumb">' +
          (p.image ? '<img src="'+p.image+'" alt="">' : '<span class="ab-thumb-label">'+comp.toUpperCase().slice(0,3)+'</span>') +
        '</div>' +
        '<div class="ab-sidebar-info">' +
          '<span class="ab-sidebar-name">'+escHtml(p.title)+customTag+'</span>' +
          priceEditHtml + costLineHtml +
        '</div>' +
        '<div class="ab-sidebar-qty">' +
          '<button type="button" class="ab-qty-minus" data-comp="'+comp+'">−</button>' +
          '<span class="ab-qty-val">'+qty+'</span>' +
          '<button type="button" class="ab-qty-plus" data-comp="'+comp+'">+</button>' +
        '</div>' +
        '<button type="button" class="ab-sidebar-remove" data-comp="'+comp+'" title="Remove">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>';
      container.appendChild(row);
    });

    if (empty) empty.style.display = hasAny ? 'none' : 'block';

    var costBreakdown = $('abCostBreakdown');
    if (costBreakdown) costBreakdown.style.display = hasAny ? '' : 'none';

    var totalCostEl = $('abTotalCost');
    if (totalCostEl) totalCostEl.textContent = 'RM ' + totalCost.toFixed(2);

    var subtotalEl = $('abSubtotal');
    if (subtotalEl) subtotalEl.textContent = 'RM ' + total.toFixed(2);

    updateMarginDisplay();
    updateDiscountDisplay();

    var nett = getNettTotal();
    var totalEl = $('abSidebarTotal');
    if (totalEl) totalEl.textContent = 'RM ' + nett.toFixed(2);

    var quoteBtn = $('abDownloadQuote');
    if (quoteBtn) quoteBtn.disabled = !hasAny;

    updateAdminLoanCalculator();
    var badge = $('abLoanModalTotal');
    if (badge) badge.textContent = 'RM ' + nett.toFixed(2);
  }

  function updateMarginDisplay() {
    var totalCost = getTotalCost();
    var quotePrice = getNettTotal();   // margin is measured against nett (after discount)
    var profit = quotePrice - totalCost;
    var marginPct = quotePrice > 0 ? (profit / quotePrice * 100) : 0;
    var isNeg = profit < 0;
    var marginRow = $('abMarginRow'), marginPctEl = $('abMarginPct'), marginAmtEl = $('abMarginAmt'), marginBar = $('abMarginBar');
    if (marginRow) marginRow.classList.toggle('negative', isNeg);
    if (marginPctEl) marginPctEl.textContent = marginPct.toFixed(1) + '%';
    if (marginAmtEl) marginAmtEl.textContent = (isNeg ? '-' : '') + 'RM ' + Math.abs(profit).toFixed(2) + (isNeg ? ' loss' : ' profit');
    if (marginBar) marginBar.style.width = Math.min(Math.abs(marginPct), 100) + '%';
  }

  // ==================== DISCOUNT DISPLAY ====================
  function updateDiscountDisplay() {
    var subtotal   = getTotal();
    var discAmt    = getDiscountAmt();
    var nett       = subtotal - discAmt;
    var hasDisc    = discAmt > 0;

    // Discount amount row
    var discRow = $('abDiscountRow');
    if (discRow) discRow.style.display = hasDisc ? '' : 'none';
    var discAmtEl = $('abDiscountAmt');
    if (discAmtEl) discAmtEl.textContent = '− RM ' + discAmt.toFixed(2);

    // Discount pct hint (shown when mode is fixed, shows effective %)
    var discHintEl = $('abDiscountPctHint');
    if (discHintEl) {
      if (hasDisc && discountMode === 'fixed' && subtotal > 0) {
        discHintEl.textContent = '(' + ((discAmt / subtotal) * 100).toFixed(1) + '%)';
        discHintEl.style.display = '';
      } else {
        discHintEl.style.display = 'none';
      }
    }

    // Nett total row
    var nettRow = $('abNettRow');
    if (nettRow) nettRow.style.display = hasDisc ? '' : 'none';
    var nettValEl = $('abNettTotal');
    if (nettValEl) nettValEl.textContent = 'RM ' + nett.toFixed(2);

    // Main total line label changes when discount active
    var totalLbl = $('abSidebarTotalLabel');
    if (totalLbl) totalLbl.textContent = hasDisc ? 'Nett Total' : 'Total';

    // Discount input value sync
    var inp = $('abDiscountInput');
    if (inp && document.activeElement !== inp) {
      inp.value = discountValue > 0 ? discountValue : '';
    }
  }

  // ==================== DISCOUNT CONTROLS SETUP ====================
  function setupDiscountControls() {
    // Mode toggle buttons (% / RM)
    document.querySelectorAll('.ab-disc-mode-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        discountMode = btn.dataset.mode;
        discountValue = 0;
        var inp = $('abDiscountInput');
        if (inp) { inp.value = ''; inp.placeholder = discountMode === 'pct' ? 'e.g. 10' : 'e.g. 50'; }
        var suffix = $('abDiscSuffix');
        if (suffix) suffix.textContent = discountMode === 'pct' ? '%' : 'RM';
        document.querySelectorAll('.ab-disc-mode-btn').forEach(function(b) {
          b.classList.toggle('active', b.dataset.mode === discountMode);
        });
        updateDiscountDisplay();
        updateMarginDisplay();
        var nett = getNettTotal();
        var totalEl = $('abSidebarTotal'); if (totalEl) totalEl.textContent = 'RM ' + nett.toFixed(2);
        updateAdminLoanCalculator();
        var badge = $('abLoanModalTotal'); if (badge) badge.textContent = 'RM ' + nett.toFixed(2);
      });
    });

    // Input
    var discInp = $('abDiscountInput');
    if (discInp) {
      discInp.addEventListener('input', function() {
        var v = parseFloat(this.value);
        discountValue = (isNaN(v) || v < 0) ? 0 : v;
        if (discountMode === 'pct' && discountValue > 100) discountValue = 100;
        updateDiscountDisplay();
        updateMarginDisplay();
        var nett = getNettTotal();
        var totalEl = $('abSidebarTotal'); if (totalEl) totalEl.textContent = 'RM ' + nett.toFixed(2);
        updateAdminLoanCalculator();
        var badge = $('abLoanModalTotal'); if (badge) badge.textContent = 'RM ' + nett.toFixed(2);
      });
    }
  }

  // ==================== QTY, REMOVE & PRICE EDIT DELEGATION ====================
  function setupQtyDelegation() {
    document.addEventListener('click', function(e) {
      var qBtn = e.target.closest('.ab-qty-minus, .ab-qty-plus');
      if (qBtn) {
        e.preventDefault();
        var comp = qBtn.dataset.comp;
        if (!comp || !sel[comp]) return;
        var delta = qBtn.classList.contains('ab-qty-plus') ? 1 : -1;
        sel[comp].qty = Math.max(1, (sel[comp].qty||1) + delta);
        updateAccordionState(); updateSidebar(); return;
      }
      var rmBtn = e.target.closest('.ab-sidebar-remove');
      if (rmBtn) {
        e.preventDefault();
        var comp2 = rmBtn.dataset.comp;
        if (!comp2) return;
        sel[comp2] = null;
        var ddId = CAT_DD_MAP[comp2];
        var dd = ddId ? $(ddId) : null;
        if (dd) dd.value = '';
        onChange(comp2);
      }
    });

    document.addEventListener('input', function(e) {
      if (!e.target.classList.contains('ab-price-input')) return;
      var comp = e.target.dataset.comp;
      if (!comp || !sel[comp]) return;
      var val = parseFloat(e.target.value);
      sel[comp].customPrice = (isNaN(val) || val < 0) ? null : val;
      updateSidebarTotals();
    });

    document.addEventListener('focusout', function(e) {
      if (!e.target.classList.contains('ab-price-input')) return;
      setTimeout(function() { updateSidebar(); }, 50);
    });
  }

  function updateSidebarTotals() {
    var total = 0, totalCost = 0;
    COMPS.forEach(function(comp) {
      var p = sel[comp]; if (!p) return;
      var qty = p.qty || 1;
      total += getItemPrice(p) * qty;
      totalCost += (p.costRaw || 0) * qty;
    });
    var totalCostEl = $('abTotalCost'); if (totalCostEl) totalCostEl.textContent = 'RM ' + totalCost.toFixed(2);
    var subtotalEl = $('abSubtotal'); if (subtotalEl) subtotalEl.textContent = 'RM ' + total.toFixed(2);
    updateDiscountDisplay();
    updateMarginDisplay();
    var nett = getNettTotal();
    var totalEl = $('abSidebarTotal'); if (totalEl) totalEl.textContent = 'RM ' + nett.toFixed(2);

    document.querySelectorAll('.ab-price-input').forEach(function(input) {
      var comp = input.dataset.comp; var p = sel[comp]; if (!p) return;
      var effectivePrice = getItemPrice(p), qty = p.qty || 1;
      var itemTotal = effectivePrice * qty, itemCost = (p.costRaw || 0) * qty, itemProfit = itemTotal - itemCost;
      var hasChanged = (p.customPrice !== null && p.customPrice !== undefined && p.customPrice !== p.priceRaw);
      var wrap = input.closest('.ab-price-input-wrap');
      if (wrap) wrap.classList.toggle('ab-price-changed', hasChanged);
      var editRow = input.closest('.ab-sidebar-price-edit');
      if (editRow) {
        var origEl = editRow.querySelector('.ab-sidebar-original-price');
        if (hasChanged) {
          if (!origEl) { origEl = document.createElement('span'); origEl.className = 'ab-sidebar-original-price'; editRow.insertBefore(origEl, editRow.firstChild); }
          origEl.textContent = 'RM ' + p.priceRaw.toFixed(2); origEl.style.display = '';
        } else if (origEl) { origEl.style.display = 'none'; }
        var qtyHint = editRow.querySelector('.ab-price-qty-hint');
        if (qty > 1) {
          if (!qtyHint) { qtyHint = document.createElement('span'); qtyHint.className = 'ab-price-qty-hint'; editRow.appendChild(qtyHint); }
          qtyHint.textContent = '× ' + qty + ' = RM ' + itemTotal.toFixed(2); qtyHint.style.display = '';
        } else if (qtyHint) { qtyHint.style.display = 'none'; }
      }
      var row = input.closest('.ab-sidebar-row');
      if (row) {
        var profitEl = row.querySelector('.ab-sidebar-profit-val');
        if (profitEl) { profitEl.textContent = (itemProfit >= 0 ? '+' : '-') + 'RM ' + Math.abs(itemProfit).toFixed(2); profitEl.classList.toggle('negative', itemProfit < 0); }
      }
    });
    updateMarginDisplay();
    updateAdminLoanCalculator();
  }

  // ==================== DROPDOWN SEARCH ====================
  function setupDropdownSearch() {
    document.querySelectorAll('.ab-dropdown-wrap').forEach(function(wrap) {
      var search = wrap.querySelector('.ab-search');
      var dd = wrap.querySelector('select');
      if (!search || !dd) return;
      var isOpen = false, closeTimer = null, justClosed = false;

      var open = function() {
        if (isOpen) return;
        isOpen = true; justClosed = false;
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        dd.setAttribute('size','8'); dd.classList.add('ab-dd-open'); search.style.display = 'block';
        requestAnimationFrame(function(){ setTimeout(function(){ if(isOpen) search.focus(); },50); });
      };

      var close = function() {
        if (!isOpen) return;
        isOpen = false; justClosed = true;
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        search.style.display = 'none'; search.value = '';
        dd.removeAttribute('size'); dd.classList.remove('ab-dd-open');
        dd.querySelectorAll('option[data-hidden-by-search]').forEach(function(o){ o.style.display=''; o.removeAttribute('data-hidden-by-search'); });
        dd.querySelectorAll('option[data-hidden-by-filter]').forEach(function(o){ o.style.display='none'; });
        setTimeout(function(){ justClosed = false; }, 100);
      };

      var processSelection = function(val) {
        var comp = dd.dataset.component;
        var curId = sel[comp] ? sel[comp].id : null;
        if (curId === val) { dd.value = ''; sel[comp] = null; onChange(comp); }
        else { dd.value = val; dd._lbHandled = true; handleDDChange(dd); }
      };

      var scheduleClose = function() {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function(){
          if (document.activeElement === search || document.activeElement === dd) return;
          if (justClosed) return;
          close();
        }, 180);
      };

      dd.addEventListener('mousedown', function(e) {
        if (!isOpen) { e.preventDefault(); open(); return; }
        var clicked = e.target.closest ? e.target.closest('option') : null;
        if (!clicked && e.target.tagName === 'OPTION') clicked = e.target;
        if (clicked && clicked.value) { e.preventDefault(); e.stopPropagation(); processSelection(clicked.value); close(); dd.blur(); }
      });

      dd.addEventListener('focus', function() { if(closeTimer){clearTimeout(closeTimer);closeTimer=null;} if(!justClosed) open(); });
      dd.addEventListener('blur', scheduleClose);
      search.addEventListener('blur', scheduleClose);
      search.addEventListener('focus', function() { if(closeTimer){clearTimeout(closeTimer);closeTimer=null;} if(!isOpen) open(); });
      ['mousedown','click'].forEach(function(evt){ search.addEventListener(evt, function(e){ e.stopPropagation(); }); });

      search.addEventListener('input', function() {
        var q = this.value.toLowerCase().trim();
        dd.querySelectorAll('option').forEach(function(o) {
          if (!o.value) return;
          if (o.hasAttribute('data-hidden-by-filter')) return;
          var m = !q || (o.dataset.title||'').toLowerCase().includes(q) || o.textContent.toLowerCase().includes(q);
          o.style.display = m ? '' : 'none';
          m ? o.removeAttribute('data-hidden-by-search') : o.setAttribute('data-hidden-by-search','true');
        });
      });

      search.addEventListener('keydown', function(e) {
        if (e.key==='Escape') { search.value=''; search.dispatchEvent(new Event('input')); close(); dd.blur(); }
        if (e.key==='Enter') {
          e.preventDefault();
          var first = Array.from(dd.options).find(function(o){ return o.value && o.style.display!=='none' && !o.hasAttribute('data-hidden-by-filter'); });
          if (first) { processSelection(first.value); close(); dd.blur(); }
        }
      });
    });
  }

  // ==================== RESET ====================
  function resetBuild() {
    COMPS.forEach(function(c) { sel[c] = null; });
    document.querySelectorAll('.ab-dropdown').forEach(function(dd){ dd.value = ''; });
    // reset discount
    discountValue = 0; discountMode = 'pct';
    var inp = $('abDiscountInput'); if (inp) inp.value = '';
    document.querySelectorAll('.ab-disc-mode-btn').forEach(function(b) {
      b.classList.toggle('active', b.dataset.mode === 'pct');
    });
    onChange('case'); filterMotherboards(); filterRAM(); abOpenSection(1);
  }

  // ==================== PDF PRICE TOGGLE ====================
  window.abTogglePdfPrice = function() {
    pdfShowPrices = !pdfShowPrices;
    var btn   = $('abPdfPriceSwitch');
    var row   = $('abPdfPriceRow');
    var label = row ? row.querySelector('.ab-pdf-price-toggle-label') : null;
    if (btn)   btn.classList.toggle('ab-toggle-on', pdfShowPrices);
    if (label) label.textContent = pdfShowPrices ? 'Show prices in PDF' : 'Hide prices in PDF';
    if (row)   row.style.borderColor = pdfShowPrices ? '' : 'rgba(245,158,11,0.3)';
  };

  // ==================== LOAN CALCULATOR ====================
  window.abOpenLoanModal = function() {
    var badge = $('abLoanModalTotal');
    if (badge) badge.textContent = 'RM ' + getTotal().toFixed(2);
    var overlay = $('abLoanOverlay');
    if (overlay) overlay.classList.add('active');
    updateAdminLoanCalculator();
  };

  window.abCloseLoanModal = function(event) {
    if (event && event.target !== event.currentTarget) return;
    var overlay = $('abLoanOverlay');
    if (overlay) overlay.classList.remove('active');
  };

  function setupLoanCalculator() {
    document.querySelectorAll('.ab-loan-plan-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var plan = btn.dataset.plan;
        var idx = activeLoanPlanTypes.indexOf(plan);
        if (idx > -1) {
          activeLoanPlanTypes.splice(idx, 1);
          if (plan === 'cc') { activeLoanCCBank = null; var dd = $('abLoanCCBankDD'); if (dd) dd.value = ''; var g = $('abLoanCCGrid'); if (g) g.innerHTML = ''; }
          if (plan === 'bnpl') {
            activeLoanBNPLProvider = null;
            document.querySelectorAll('.ab-loan-bnpl-btn').forEach(function(b){ b.classList.remove('active'); });
            var r = $('abLoanBNPLResult'); if (r) r.innerHTML = '';
          }
        } else {
          activeLoanPlanTypes.push(plan);
          if (plan === 'aeon') renderAEONGrid();
        }
        updateLoanUI();
      });
    });

    var ccDD = $('abLoanCCBankDD');
    if (ccDD) ccDD.addEventListener('change', function() {
      activeLoanCCBank = this.value || null;
      renderCCMonthGrid();
    });

    document.querySelectorAll('.ab-loan-bnpl-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var p = btn.dataset.provider;
        activeLoanBNPLProvider = (activeLoanBNPLProvider === p) ? null : p;
        document.querySelectorAll('.ab-loan-bnpl-btn').forEach(function(b) {
          b.classList.toggle('active', b.dataset.provider === activeLoanBNPLProvider);
        });
        renderBNPLResult();
      });
    });
  }

  function updateLoanUI() {
    document.querySelectorAll('.ab-loan-plan-btn').forEach(function(btn) {
      btn.classList.toggle('active', activeLoanPlanTypes.indexOf(btn.dataset.plan) > -1);
    });
    var panelMap = { cc: 'abLoanCCPanel', bnpl: 'abLoanBNPLPanel', aeon: 'abLoanAEONPanel' };
    Object.keys(panelMap).forEach(function(key) {
      var el = $(panelMap[key]);
      if (el) el.classList.toggle('active', activeLoanPlanTypes.indexOf(key) > -1);
    });
    updateLoanPDFData();
  }

  function renderCCMonthGrid() {
    var grid = $('abLoanCCGrid');
    if (!grid) return;
    grid.innerHTML = '';
    if (!activeLoanCCBank) return;
    var cfg = LOAN_BANK_CONFIG[activeLoanCCBank];
    if (!cfg) return;
    var total = getTotal();
    cfg.months.forEach(function(m) {
      var fee     = CC_FEES[m] || 0;
      var monthly = total * (1 + fee / 100) / m;
      var totalPay = monthly * m;
      grid.appendChild(buildMonthCard(m, monthly, totalPay, fee + '% fee'));
    });
    updateLoanPDFData();
  }

  // ── BNPL: render with processing fee (GrabPay 6%, SPayLater 3%) ──
  function renderBNPLResult() {
    var container = $('abLoanBNPLResult');
    if (!container) return;
    container.innerHTML = '';
    if (!activeLoanBNPLProvider) return;
    var prov = BNPL_PROVIDERS[activeLoanBNPLProvider];
    if (!prov) return;
    var principal = getTotal();
    var feeAmt    = principal * (prov.feeRate / 100);
    var totalPay  = principal + feeAmt;
    var monthly   = totalPay / prov.months;

    var div = document.createElement('div');
    div.className = 'ab-loan-bnpl-result-card';
    div.innerHTML =
      '<span class="ab-loan-bnpl-result-lbl">' + prov.label + ' · up to ' + prov.months + ' months</span>' +
      '<span class="ab-loan-bnpl-result-amount">RM ' + monthly.toFixed(2) + '</span>' +
      '<span class="ab-loan-bnpl-result-sub">per month &nbsp;·&nbsp; Processing fee: ' + prov.feeRate + '% (RM ' + feeAmt.toFixed(2) + ')</span>' +
      '<span class="ab-loan-bnpl-result-sub">Total payable: RM ' + totalPay.toFixed(2) + '</span>';
    container.appendChild(div);
    updateLoanPDFData();
  }

  // ── AEON: 6 / 12 / 18 / 24 / 30 / 36 months, rate depends on principal, show fees ──
  function renderAEONGrid() {
    var grid = $('abLoanAEONGrid');
    if (!grid) return;
    grid.innerHTML = '';
    var principal = getTotal();
    var rate      = getAeonMonthlyRate(principal);
    var stampFee  = getAeonStampingFee(principal);
    var totalFees = AEON_PROCESSING_FEE + stampFee;
    var financeAmt = principal + totalFees; // amount financed includes fees

    // Show fee note above grid
    var noteEl = document.getElementById('abLoanAEONNote');
    if (noteEl) {
      noteEl.textContent =
        rate + '%/month · Processing fee: RM' + AEON_PROCESSING_FEE +
        ' · Stamping fee: RM' + stampFee +
        ' · Total fees: RM' + totalFees.toFixed(2);
    }

    AEON_MONTHS.forEach(function(m) {
      var monthly  = financeAmt * (1 + (rate / 100) * m) / m;
      var totalPay = monthly * m;
      var feeLabel = (rate * m).toFixed(0) + '% total';
      grid.appendChild(buildMonthCard(m, monthly, totalPay, feeLabel));
    });
    updateLoanPDFData();
  }

  function buildMonthCard(months, monthly, totalPayable, feeLabel) {
    var card = document.createElement('div');
    card.className = 'ab-loan-month-card';
    card.innerHTML =
      '<div class="ab-loan-month-card-header">' +
        '<span class="ab-loan-month-label">' + months + ' Months</span>' +
        '<span class="ab-loan-month-fee">' + feeLabel + '</span>' +
      '</div>' +
      '<span class="ab-loan-month-amount">RM ' + monthly.toFixed(2) + '</span>' +
      '<span class="ab-loan-month-per">per month</span>' +
      '<span class="ab-loan-month-total">Total payable: RM ' + totalPayable.toFixed(2) + '</span>';
    return card;
  }

  function updateAdminLoanCalculator() {
    if (activeLoanPlanTypes.indexOf('cc')   > -1 && activeLoanCCBank)       renderCCMonthGrid();
    if (activeLoanPlanTypes.indexOf('bnpl') > -1 && activeLoanBNPLProvider) renderBNPLResult();
    if (activeLoanPlanTypes.indexOf('aeon') > -1)                           renderAEONGrid();
    updateLoanPDFData();
  }

  function updateLoanPDFData() {
    loanPDFData = [];
    if (activeLoanPlanTypes.indexOf('cc') > -1 && activeLoanCCBank) {
      var cfg = LOAN_BANK_CONFIG[activeLoanCCBank];
      loanPDFData.push({ planType: 'cc', bankLabel: cfg ? cfg.label : activeLoanCCBank, months: cfg ? cfg.months : [] });
    }
    if (activeLoanPlanTypes.indexOf('bnpl') > -1 && activeLoanBNPLProvider) {
      var prov = BNPL_PROVIDERS[activeLoanBNPLProvider];
      loanPDFData.push({ planType: 'bnpl', providerLabel: prov ? prov.label : activeLoanBNPLProvider, feeRate: prov ? prov.feeRate : 0, months: prov ? prov.months : 3 });
    }
    if (activeLoanPlanTypes.indexOf('aeon') > -1) {
      loanPDFData.push({ planType: 'aeon', months: AEON_MONTHS });
    }
  }

  // ==================== PDF QUOTE ====================
  async function generateQuotePDF() {
    if (!window.jspdf || !window.jspdf.jsPDF) return;
    var jsPDF = window.jspdf.jsPDF;
    var items = COMPS.map(function(c){ return sel[c] ? { comp: c, item: sel[c] } : null; }).filter(Boolean);
    if (!items.length) return;

    var quoteNum = '';
    try {
      var apiUrl = window.QUOTE_API_URL || '/api/quote-number';
      var qRes = await fetch(apiUrl, { method:'POST', headers:{'Content-Type':'application/json'} });
      var qData = await qRes.json();
      if (qData.success) quoteNum = qData.quoteNumber;
      else throw new Error(qData.error);
    } catch(e) {
      var today_fb = new Date();
      var fbCount = parseInt(localStorage.getItem('abQuoteCount')||'0',10)+1;
      localStorage.setItem('abQuoteCount', fbCount);
      quoteNum = 'QT-'+today_fb.getFullYear()+String(today_fb.getMonth()+1).padStart(2,'0')+String(today_fb.getDate()).padStart(2,'0')+'-'+String(fbCount).padStart(4,'0');
    }

    var imageCache = {};
    await Promise.all(items.map(async function(entry) {
      var item = entry.item;
      if (item.image && !imageCache[item.id]) {
        try {
          if (item.image.startsWith('data:')) {
            imageCache[item.id] = item.image;
          } else {
            var url = item.image.replace('_medium','_large').replace('_small','_large');
            var data = await loadImg(url);
            if (data) imageCache[item.id] = data;
          }
        } catch(e){}
      }
    }));

    var doc = new jsPDF({unit:'mm',format:'a4'});
    var W=210, H=297, mg=18, cW=W-mg*2;
    var dark=[15,17,30], dim=[120,128,155], acc=[59,130,246], acc2=[168,85,247], white=[255,255,255], line=[35,40,65], cardBg=[20,24,42], alt=[18,21,38];

    function rr(x,y,w,h,r){ doc.roundedRect(x,y,w,h,r,r,'F'); }
    function newPage(){ doc.addPage(); doc.setFillColor.apply(doc,dark); doc.rect(0,0,W,H,'F'); doc.setFillColor.apply(doc,acc); doc.rect(0,0,W,2.5,'F'); return mg+6; }
    function chk(y,need){ return y+need>H-20?newPage():y; }

    doc.setFillColor.apply(doc,dark); doc.rect(0,0,W,H,'F');
    doc.setFillColor.apply(doc,acc); doc.rect(0,0,W,2.5,'F');
    var y = mg;

    var logoLoaded = false;
    if (window.ENOTEX_LOGO_URL) {
      try {
        var logoData = await loadImg(window.ENOTEX_LOGO_URL);
        if (logoData) { var lw=65, lh=lw*0.245; doc.addImage(logoData,'PNG',mg,y-4,lw,lh); logoLoaded=true; }
      } catch(e){}
    }
    if (!logoLoaded) { doc.setFont('helvetica','bold'); doc.setFontSize(20); doc.setTextColor.apply(doc,white); doc.text('ENOTEX | PC',mg,y+6); }

    doc.setFont('helvetica','normal'); doc.setFontSize(9); doc.setTextColor.apply(doc,dim);
    doc.text('QUOTATION', W-mg, y+2, {align:'right'});
    var today = new Date();
    var dateStr = today.toLocaleDateString('en-MY',{day:'numeric',month:'long',year:'numeric'});
    doc.text('Date: '+dateStr, W-mg, y+7, {align:'right'});
    doc.text('Ref: '+quoteNum, W-mg, y+12, {align:'right'});

    y += (logoLoaded ? 65*0.245 : 10) + 3;
    doc.setFont('helvetica','normal'); doc.setFontSize(7.5); doc.setTextColor.apply(doc,dim);
    doc.text('ENOTEX PC SDN.BHD. 202201022241 (1467938-U)', mg, y); y+=3.5;
    doc.text('NO.33G, JALAN METRO PERDANA 7, TAMAN USAHAWAN KEPONG,', mg, y); y+=3.5;
    doc.text('52100 KUALA LUMPUR.', mg, y); y+=3.5;
    doc.text('TEL: 03-62419486   |   EMAIL: sales@etexpc.com', mg, y); y+=6;
    doc.setDrawColor.apply(doc,acc); doc.setLineWidth(0.5); doc.line(mg,y,W-mg,y); y+=8;

    y=chk(y,12);
    doc.setFillColor.apply(doc,cardBg); rr(mg,y,cW,8,2);
    doc.setFont('helvetica','bold'); doc.setFontSize(7.5); doc.setTextColor.apply(doc,acc);
    var qtyX = pdfShowPrices ? W-mg-60 : W-mg-30;
    doc.text('COMPONENT / PRODUCT',mg+4,y+5.5);
    doc.text('QTY',qtyX,y+5.5,{align:'center'});
    if (pdfShowPrices) doc.text('AMOUNT (RM)',W-mg-4,y+5.5,{align:'right'});
    y+=11;

    var grandTotal=0, thumbSz=16, txtX=mg+4+thumbSz+3, nameW=qtyX-txtX-8;

    items.forEach(function(entry,i) {
      var item=entry.item, comp=entry.comp;
      var qty=item.qty||1, unitPrice=getItemPrice(item), sub=unitPrice*qty;
      var label=(LABELS[comp]||comp).toUpperCase(), hasImg=!!imageCache[item.id];
      doc.setFont('helvetica','normal'); doc.setFontSize(8.5);
      var wrapped=doc.splitTextToSize(item.title||'',nameW);
      var unitH=qty>1?3.5:0;
      var textH=3+3.5+1.5+(wrapped.length*3.8)+unitH+3;
      var rowH=Math.max(textH,3+thumbSz+3);
      y=chk(y,rowH);
      if(i%2===0){doc.setFillColor.apply(doc,alt);doc.rect(mg,y,cW,rowH,'F');}
      var tx=mg+4, ty=y+(rowH-thumbSz)/2;
      doc.setFillColor.apply(doc,cardBg); doc.roundedRect(tx-0.5,ty-0.5,thumbSz+1,thumbSz+1,1.5,1.5,'F');
      if(hasImg){
        try{ var fmt=imageCache[item.id].includes('image/png')?'PNG':'JPEG'; doc.addImage(imageCache[item.id],fmt,tx,ty,thumbSz,thumbSz,undefined,'FAST'); }catch(e){}
      } else { doc.setFont('helvetica','bold');doc.setFontSize(5);doc.setTextColor.apply(doc,dim);doc.text(label.slice(0,3),tx+thumbSz/2,ty+thumbSz/2+1.5,{align:'center'}); }
      var totalTH=3.5+1.5+(wrapped.length*3.8)+unitH;
      var sY=y+(rowH-totalTH)/2;
      doc.setFont('helvetica','bold');doc.setFontSize(7);doc.setTextColor.apply(doc,acc2);
      doc.text(label,txtX,sY+2.5); sY+=3.5+1.5;
      doc.setFont('helvetica','normal');doc.setFontSize(8.5);doc.setTextColor.apply(doc,white);
      wrapped.forEach(function(l,li){doc.text(l,txtX,sY+2.5+(li*3.8));});
      if(qty>1){doc.setFont('helvetica','normal');doc.setFontSize(7);doc.setTextColor.apply(doc,dim);doc.text('@ RM '+unitPrice.toFixed(2)+' each',txtX,sY+2.5+(wrapped.length*3.8)+1);}
      var midY=y+(rowH/2)+1;
      doc.setFont('helvetica','bold');doc.setFontSize(9);doc.setTextColor.apply(doc,white);
      doc.text(String(qty),qtyX,midY,{align:'center'});
      if (pdfShowPrices) doc.text(sub.toFixed(2),W-mg-4,midY,{align:'right'});
      doc.setDrawColor.apply(doc,line);doc.setLineWidth(0.15);doc.line(mg+4,y+rowH,W-mg-4,y+rowH);
      grandTotal+=sub; y+=rowH;
    });

// ==================== TOTALS / DISCOUNT BLOCK ====================
y += 4; y = chk(y, 25);
doc.setDrawColor.apply(doc, line); doc.setLineWidth(0.3);
doc.line(mg, y, W - mg, y); y += 6;

var hasDiscount = pdfShowPrices && getDiscountAmt() > 0;
var pdfNett     = pdfShowPrices ? getNettTotal() : grandTotal;
var sumW        = 74;                 // matches TOTAL card width
var sumX        = W - mg - sumW;      // left edge of summary column
var sumLabelX   = sumX + 4;
var sumValueX   = W - mg - 4;

// Subtotal + Discount sub-rows (only when a discount is active)
if (hasDiscount) {
  var discAmt = getDiscountAmt();
  var discLabelTxt = discountMode === 'pct'
    ? 'Discount (' + discountValue + '%)'
    : 'Discount';

  // Subtotal
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5);
  doc.setTextColor.apply(doc, dim);
  doc.text('Subtotal', sumLabelX, y + 3);
  doc.setTextColor.apply(doc, white);
  doc.text('RM ' + grandTotal.toFixed(2), sumValueX, y + 3, { align: 'right' });
  y += 5.5;

  // Discount
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5);
  doc.setTextColor.apply(doc, dim);
  doc.text(discLabelTxt, sumLabelX, y + 3);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(239, 68, 68);
  doc.text('- RM ' + discAmt.toFixed(2), sumValueX, y + 3, { align: 'right' });
  y += 6;

  // Mini divider — only spans the summary column, leads the eye into TOTAL
  doc.setDrawColor.apply(doc, line); doc.setLineWidth(0.2);
  doc.line(sumX + 2, y, W - mg - 2, y);
  y += 3;
}

// TOTAL card
doc.setFillColor.apply(doc, cardBg); rr(sumX, y - 4, sumW, 13, 2);
doc.setFont('helvetica', 'bold'); doc.setFontSize(10);
doc.setTextColor.apply(doc, dim);
doc.text('TOTAL', sumLabelX, y + 3.5);
doc.setFontSize(13); doc.setTextColor.apply(doc, white);
doc.text('RM ' + pdfNett.toFixed(2), sumValueX, y + 4, { align: 'right' });

// Component count (left side, aligned with TOTAL card)
var totalQty = Object.values(sel).filter(Boolean)
  .reduce(function (s, i) { return s + (i.qty || 1); }, 0);
var uniq = Object.values(sel).filter(Boolean).length;
doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5);
doc.setTextColor.apply(doc, dim);
var cntTxt = uniq + ' component' + (uniq !== 1 ? 's' : '');
if (totalQty > uniq) cntTxt += ' (' + totalQty + ' items total)';
doc.text(cntTxt, mg, y + 4);
y += 20;

    // For loan calculations use nett total
    var loanBase = pdfShowPrices ? pdfNett : grandTotal;

    // ==================== LOAN SECTION IN PDF ====================
    if (pdfShowPrices && loanPDFData && loanPDFData.length > 0 && loanBase > 0) {
      var planTitles = { cc:'Credit Card Instalment', bnpl:'BNPL Instalment', aeon:'AEON Credit Service' };

      loanPDFData.forEach(function(planEntry) {
        var planTitle = planTitles[planEntry.planType] || 'Instalment Plan';
        var subLabel = '', rateNote = '';

        if (planEntry.planType === 'cc') {
          subLabel = planEntry.bankLabel || '';
          rateNote = '0% interest — processing fee per term';
        } else if (planEntry.planType === 'bnpl') {
          subLabel = planEntry.providerLabel || '';
          rateNote = planEntry.feeRate + '% processing fee · up to ' + planEntry.months + ' months';
        } else if (planEntry.planType === 'aeon') {
          var aRate      = getAeonMonthlyRate(loanBase);
          var aStamp     = getAeonStampingFee(loanBase);
          var aTotalFees = AEON_PROCESSING_FEE + aStamp;
          subLabel = 'Easy Payment Plan';
          rateNote = aRate + '%/month · Processing: RM' + AEON_PROCESSING_FEE + ' · Stamping: RM' + aStamp + ' · Fees: RM' + aTotalFees;
        }

        var monthList = planEntry.planType === 'bnpl'
          ? [planEntry.months]
          : planEntry.months;

        if (!monthList || monthList.length === 0) return;

        var cardCount = monthList.length;
        y = chk(y, 10 + 8 + (cardCount > 0 ? 18 : 0) + 8);

        doc.setFont('helvetica','bold'); doc.setFontSize(8); doc.setTextColor.apply(doc,acc2);
        doc.text(planTitle.toUpperCase(), mg, y); y += 5;

        doc.setFillColor.apply(doc,cardBg); rr(mg,y,cW,7,1.5);
        doc.setFont('helvetica','bold'); doc.setFontSize(8); doc.setTextColor.apply(doc,white);
        doc.text(subLabel, mg+4, y+4.8);
        doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor.apply(doc,dim);
        doc.text(rateNote, W-mg-4, y+4.8, {align:'right'});
        y += 10;

        var lBoxW = cardCount <= 2 ? (cW-(cardCount-1)*3)/cardCount : (cW-9)/4;

        monthList.forEach(function(m, i) {
          if (i > 0 && i % 4 === 0) { y += 16; y = chk(y, 16); }
          var col = i % 4, x = mg + col * (lBoxW + 3);
          var monthly, totalPay, feeStr;

          if (planEntry.planType === 'cc') {
            var fee = CC_FEES[m] || 0;
            monthly = loanBase * (1 + fee / 100) / m;
            totalPay = monthly * m;
            feeStr = fee + '% fee';
          } else if (planEntry.planType === 'bnpl') {
            var fRate = planEntry.feeRate || 0;
            var fAmt  = loanBase * (fRate / 100);
            monthly   = (loanBase + fAmt) / m;
            totalPay  = monthly * m;
            feeStr    = fRate + '% fee';
          } else {
            var aR  = getAeonMonthlyRate(loanBase);
            var aSt = getAeonStampingFee(loanBase);
            var aFA = loanBase + AEON_PROCESSING_FEE + aSt;
            monthly  = aFA * (1 + (aR / 100) * m) / m;
            totalPay = monthly * m;
            feeStr   = (aR * m).toFixed(0) + '% total';
          }

          doc.setFillColor.apply(doc,alt); rr(x,y,lBoxW,14,2);
          doc.setFont('helvetica','normal'); doc.setFontSize(6.5); doc.setTextColor.apply(doc,dim);
          doc.text(
            planEntry.planType === 'bnpl' ? m + '× pmts' : m + ' months',
            x+lBoxW/2, y+4, {align:'center'}
          );
          doc.setFont('helvetica','bold'); doc.setFontSize(8.5); doc.setTextColor.apply(doc,acc2);
          doc.text('RM ' + monthly.toFixed(2), x+lBoxW/2, y+9.5, {align:'center'});
          doc.setFont('helvetica','normal'); doc.setFontSize(5.5); doc.setTextColor.apply(doc,dim);
          doc.text(feeStr, x+lBoxW/2, y+13, {align:'center'});
        });
        y += 18;
      });

      doc.setFont('helvetica','normal'); doc.setFontSize(6.5); doc.setTextColor.apply(doc,dim);
      doc.text('* Instalment estimates only. Actual amounts subject to approval and may vary by bank/provider.', mg, y);
      y += 6;
    }

    // Footer
    doc.setFont('helvetica','normal'); doc.setFontSize(7); doc.setTextColor(80,85,110);
    doc.text('This quotation is for reference only. Prices may vary. Generated from ENOTEX PC Builder.', W/2, H-12, {align:'center'});
    doc.text('Generated: '+today.toLocaleString('en-MY'), W/2, H-8, {align:'center'});

    doc.save('PC-Build-Quotation-'+quoteNum+'.pdf');
  } // ← end of generateQuotePDF

  // ==================== IMAGE LOADER ====================
  function loadImg(url) {
    return new Promise(function(resolve) {
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function() {
        try {
          var c=document.createElement('canvas'); c.width=img.naturalWidth; c.height=img.naturalHeight;
          var ctx=c.getContext('2d'); ctx.fillStyle='#0e1120'; ctx.fillRect(0,0,c.width,c.height); ctx.drawImage(img,0,0);
          resolve(c.toDataURL('image/jpeg',0.85));
        } catch(e) { resolve(null); }
      };
      img.onerror = function() { resolve(null); };
      img.src = url;
    });
  }

  console.log('%c🔧 ADMIN BUILDER — Staff quotation tool loaded', 'color:#3b82f6;font-size:12px;font-weight:bold;');
})();